/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { log } from '@24i/nxg-core-utils/src/logger';
import Modal from '@24i/nxg-sdk-gluons/src/components/containers/Modal';
import { useModal } from '@24i/nxg-sdk-gluons/src/context/Modal';
import { useFirebase } from '@24i/nxg-sdk-smartott-shared/src/context/Firebase';
import SignOut from '../../../View/index';
import { useAuth } from '../../../../../hooks/useAuth';
import LoadingWrapper from '../../../../LoadingWrapper';
import { styles } from './styles';

interface SingOutModalViewProps<P> {
    Component: React.ComponentType<P>;
    componentProps: Record<string, unknown>;
    onCloseModal: () => void;
}

const SingOutModalView = <P,>({
    Component,
    componentProps,
    onCloseModal,
}: SingOutModalViewProps<P>) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { setModalProps } = useModal();
    const { recordError, crashlyticsLog } = useFirebase();
    const { closeModal } = useModal();
    const { logout } = useAuth();

    const closeModalComponent = () => {
        setIsModalVisible(false);
        onCloseModal?.();
    };

    const signOutOnPressHandler = async () => {
        setLoading(true);
        setIsModalVisible(false);

        try {
            closeModal();
            await logout();
            crashlyticsLog('Sign out pressed');
        } catch (error) {
            setLoading(false);
            recordError(error);
            log(error);
            /* eslint-disable no-alert */
            alert(error || 'Something went wrong...');
        }
    };

    return (
        <>
            {loading && (
                <LoadingWrapper
                    isLoading={loading}
                    shouldOverlay
                    wrapperStyle={styles.modalLoader}
                    loaderProps={{
                        size: 'large',
                    }}
                />
            )}
            <Component {...(componentProps as P)} setSignoutModalVisible={setIsModalVisible} />
            <Modal
                visible={isModalVisible && !loading}
                onRequestClose={closeModalComponent}
                transparent
            >
                <SignOut
                    onConfirm={signOutOnPressHandler}
                    onClose={closeModalComponent}
                    setModalProps={setModalProps}
                />
            </Modal>
        </>
    );
};

export default SingOutModalView;
